import { takeLatest, all, put } from 'redux-saga/effects'
import * as calls from './calls'
import * as reducerActions from '../../reducers/sessionReducer/actions'
import * as layoutActions from '../../reducers/layoutReducer/actions'
import * as Notifications from '../../components/Common/notification'

function* genGetInstalacion(e){
    try {
     
        // llamo a la acción que busca la configuración de la instalación
        let instalacion = yield calls.getInstalacion(e.payload)
        
        // almaceno la configuración de la instalación en el reducer
        yield put(reducerActions.setInstalacion(instalacion))
    }
    catch (error) 
    {
        if (error.Message) {
             
            return;
        }
    }
}



function* genGetUsuarioLogeado(e){
  try 
  {
      // llamo a la acción que busca el usuario autenticado
      let usuario = yield calls.getUsuarioLogeado(e.payload)

      if(usuario.idUsuario !== null)
      {
          // almaceno el usuario en el reductor
          yield put(reducerActions.setUsuario(usuario))
          
          // indico que el usuario está autenticado
          yield put(reducerActions.setResultadoAutenticacion({ autenticado: true }))
      }
  }
  catch (e) 
  {
  }
  finally
  {
      // indico que se finalizó la búsqueda de usuario logeado
      yield put(layoutActions.setInicializandoUsuario(false))
  }
}

function* genAutenticarUsuario(e){
  try {
      
      // muestro el loader
      yield put(layoutActions.setLoading({ show: true, message: 'Verificando sus credenciales' }))

      // limpio el resultado de autenticación
      yield put(reducerActions.setDefaultResultadoAutenticacion())

      // llamo a la acción que autentica al usuario
      let resultadoAutenticacion = yield calls.autenticarUsuario(e.payload)
      // almaceno el resultado de la autenticación en el reducer
      yield put(reducerActions.setResultadoAutenticacion({ 
          error: resultadoAutenticacion.error || undefined,
          autenticado: resultadoAutenticacion.autenticado,
          restablecerContrasenia: false,
      }))

     // yield put(reducerActions.setFlagDatosAdicionales(false))

      // almaceno el usuario en el reductor
      yield put(reducerActions.setUsuario(resultadoAutenticacion.usuario))

      // llamo a la callback de usuario autenticado
      if(resultadoAutenticacion.autenticado === true)
          e.payload.onUsuarioAutenticado()
  }
  catch (e) 
  {
      // muestro el mensaje de error
      yield put(reducerActions.setResultadoAutenticacion({ error: e.error }))
  }
  finally 
  {
      // oculto el loader
      yield put(layoutActions.setLoading({ show: false }))
  }
}

function* genRestablecerContrasenia(e){
  try
  {
      // muestro el loader
      yield put(layoutActions.setLoading({ show: true, message: 'Restableciendo claves' }))
      
      // llamo a la acción que restablece la contraseña
      yield calls.restablecerContrasenia(e.payload)

      // indico que el usuario fue autenticado
      yield put(reducerActions.setResultadoAutenticacion({ 
          error: undefined,
          autenticado: false,
          restablecerContrasenia: false ,
          token: undefined,
          usuarioId: undefined
      }))

      // llamo a la función de callback
      e.payload.onContraseniaRestablecida()
  }
  catch (e)
  {
      // muestro el mensaje de error
      yield put(reducerActions.setResultadoAutenticacion({ error: e.error }))
  }
  finally 
  {
      // oculto el loader
      yield put(layoutActions.setLoading({ show: false }))
  }
}

function* genOlvidoContrasenia(e) {
  try
  {
      // muestro el loader
      yield put(layoutActions.setLoading({ show: true }))

      // llamo a la acción que ejecuta la lógica de olvido de contraseña
      yield calls.olvidoContrasenia(e.payload)

      // indico que se finalizó con el proceso de recuperación de contraseña
      yield put(reducerActions.setResultadoAutenticacion({ claveProvisoriaGenerada: true }))
  }
  catch(e)
  {
      // muestro el mensaje de error
      yield put(reducerActions.setResultadoAutenticacion({ error: e.error }))
  }
  finally
  {
      // oculto el loader
      yield put(layoutActions.setLoading({ show: false }))
  }
}

function* genValidarCodigo(e) {

  let payload = {}
  payload.callback = e.payload.callback
  payload.callbackError = e.payload.callbackError

  try
  {
      e.payload.callback = undefined
      e.payload.callbackError = undefined
      // muestro el loader
      yield put(layoutActions.setLoading({ show: true }))

      // llamo a la acción que ejecuta la lógica de validación de codigo
      let response = yield calls.validarCodigo(e.payload)

      // indico que se finalizó con el proceso de recuperación de contraseña
      yield put(reducerActions.setResultadoAutenticacion({ claveProvisoriaGenerada: true , usuarioId: response.usuarioId, token: response.token}))

      if(payload.callback){
          payload.callback({ claveProvisoriaGenerada: true , usuarioId: response.usuarioId, token: response.token})
      }
  }
  catch(e)
  {
      // muestro el mensaje de error
      yield put(reducerActions.setResultadoAutenticacion({ error: e }))
      if(payload.callbackError){
          payload.callbackError(e)
      }
  }
  finally
  {
      // oculto el loader
      yield put(layoutActions.setLoading({ show: false }))
  }
}

function* genLogOutUsuario(e) {
  try
  {
      // muestro el loader
      yield put(layoutActions.setLoading({ show: true , message:'Cerrando Sessión'}))

      // llamo a la acción que ejecuta la lógica de cerrar la sesion
      yield calls.logOutUsuario()

      //armo objeto de autenticacion como default
      let resultadoAutenticacion = {
          error: undefined,
          autenticado: false,
          restablecerContrasenia: false,
          claveProvisoriaGenerada: false,
      }
      
    //  yield put(reducerActions.setFlagDatosAdicionales(false))

      //Seteo autenticacion como default
      yield put(reducerActions.setUsuario(undefined))

      //Seteo autenticacion como default
      yield put(reducerActions.setDefaultResultadoAutenticacion(resultadoAutenticacion))

      //Pongo usuario como undefined 
      yield put(reducerActions.setUsuario(undefined))
  }
  catch(e)
  {
      // muestro el mensaje de error
      //yield put(reducerActions.setResultadoAutenticacion({ error: e.error }))
  }
  finally
  {
      // oculto el loader
      yield put(layoutActions.setLoading({ show: false }))
  }
}

function* genGetImagenLogin(e){
  try {
      // busco la imagen de login
      
      let imagen = yield calls.getImagenLogin(e.payload)
      
      //seteo las imagen de login
      yield put(reducerActions.setImagenLogin(imagen))
  }
  catch (error) 
  {
      if (error.Message) {
           
          return;
      }
  }
  finally 
  {
  }
}

function* genSetMontoCompraMinima(e) {
    try
    {
        // muestro el loader
        yield put(layoutActions.setLoading({ show: true , message:'Actualizando monto'}))
  
        // llamo a la acción que busca la configuración de la instalación
        let instalacion = yield calls.setMontoCompraMinima(e.payload)
        
        // almaceno la configuración de la instalación en el reducer
        yield put(reducerActions.setInstalacion(instalacion))
    }
    catch(e)
    {
        // muestro el mensaje de error
    }
    finally
    {
        // oculto el loader
        yield put(layoutActions.setLoading({ show: false }))
    }
}

function* genSetConfiguracionDelivery(e) {
    try
    {
        // muestro el loader
        yield put(layoutActions.setLoading({ show: true , message:'Actualizando configuracion de delivery'}))
  
        // llamo a la acción que busca la configuración de la instalación
        let instalacion = yield calls.setConfiguracionDelivery(e.payload)
        
        // almaceno la configuración de la instalación en el reducer
        yield put(reducerActions.setInstalacion(instalacion))
    }
    catch(e)
    {
        // muestro el mensaje de error
    }
    finally
    {
        // oculto el loader
        yield put(layoutActions.setLoading({ show: false }))
    }
}

function* genPutClaveSupervisorPicking(e){
    try {
        // muestro el loader
        yield put(layoutActions.setLoading({ show: true, message: 'Restableciendo claves supervisor' }))

        // // llamo a la acción que busca la clave
        let supervisorPicking = yield calls.setNuevaClavePicking(e.payload);
        
        // almaceno la nueva clave en el reductor
        yield put(reducerActions.saveNewClaveSupervisor(supervisorPicking))
        
        Notifications.showSuccess("Clave de supervisor reestablecida correctamente")
    } catch (e) {
        Notifications.showError("No se pudo cambiar la clave del supervisor")
        yield put({ type: "CLAVE_SUPERVISOR_PICKING_FAILED", message: e.message });
    }
    finally {
        // oculto el loader
        yield put(layoutActions.setLoading({ show: false }))
    }
  }

function* defaultSaga() {
    yield all([
      takeLatest(reducerActions.SAGA_FETCH_INSTALACION, genGetInstalacion),
      takeLatest(reducerActions.SAGA_FETCH_USUARIO_LOGEADO, genGetUsuarioLogeado),
      takeLatest(reducerActions.SAGA_AUTENTICAR_USUARIO, genAutenticarUsuario),
      takeLatest(reducerActions.SAGA_RESTABLECER_CONTRASENIA, genRestablecerContrasenia),
      takeLatest(reducerActions.SAGA_OLVIDO_CONTRASENIA, genOlvidoContrasenia),
      takeLatest(reducerActions.SAGA_VALIDAR_CODIGO, genValidarCodigo),
      takeLatest(reducerActions.SAGA_LOGOUT_USUARIO, genLogOutUsuario),
      takeLatest(reducerActions.SAGA_FETCH_IMAGEN_LOGIN, genGetImagenLogin),
      takeLatest(reducerActions.SET_MONTO_COMPRAMINIMA, genSetMontoCompraMinima),
      takeLatest(reducerActions.SET_CONFIGURACION_DELIVERY, genSetConfiguracionDelivery),
      // takeLatest(reducerActions.SAGA_CLAVE_SUPERVISOR_PICKING_OLD, genGetClaveSupervisorPicking),
      takeLatest(reducerActions.SET_CLAVE_SUPERVISOR_PICKING, genPutClaveSupervisorPicking),
    ])
  }
  
  export const sagas = [
    defaultSaga
  ]